(function() {
  "use strict";
  angular.module("marketPlace.events", ["marketPlace.lodash", "marketPlace.payments", "marketPlace.preview"]);
})();
